import i18next from 'i18next';
import { LabelColor } from '../../base';
import {
    JobStatus,
    JobApplicationStatuses,
    JobApplicationStatusUpdateValues,
    UserStatus,
} from '../consts';

export const getStatusColor = (status: string): LabelColor => {
    let labelColor: LabelColor = 'warning';
    switch (status) {
        case JobStatus.Draft:
        case JobApplicationStatuses.new:
            labelColor = 'default';
            break;
        case JobStatus.Published:
            labelColor = 'info';
            break;
        case JobApplicationStatuses.hired:
        case JobStatus.Completed:
        case UserStatus.Active:
            labelColor = 'success';
            break;
        case JobStatus.Canceled:
        case JobStatus.Closed:
        case JobApplicationStatuses.declined:
        case JobApplicationStatusUpdateValues.reject:
        case JobApplicationStatuses.withdrawn:
        case JobApplicationStatusUpdateValues.withdraw:
        case UserStatus.Deactivated:
            labelColor = 'error';
            break;
        case JobApplicationStatuses.inReview:
        case JobStatus.Suspended:
        case UserStatus.Invited:
            labelColor = 'warning';
            break;
        case JobStatus.Legacy:
            labelColor = 'warning';
            break;
        default:
            break;
    }
    return labelColor;
};

export const getUserStatusLabel = (status: string) => {
    let statusLabel = '';
    switch (status) {
        case UserStatus.Active:
            statusLabel = i18next.t(`statuses.${UserStatus.Active}`);
            break;
        case UserStatus.Deactivated:
            statusLabel = i18next.t(`statuses.${UserStatus.Deactivated}`);
            break;
        case UserStatus.Invited:
            statusLabel = i18next.t(`statuses.${UserStatus.Invited}`);
            break;
        default:
            break;
    }
    return statusLabel;
};

export const getJobsStatusLabel = (status: string) => {
    let statusLabel = '';
    switch (status) {
        case JobStatus.Draft:
            statusLabel = i18next.t(`statuses.${JobStatus.Draft}`);
            break;
        case JobStatus.Published:
            statusLabel = i18next.t(`statuses.${JobStatus.Published}`);
            break;
        case JobStatus.Completed:
            statusLabel = i18next.t(`statuses.${JobStatus.Completed}`);
            break;
        case JobStatus.Canceled:
            statusLabel = i18next.t(`statuses.${JobStatus.Canceled}`);
            break;
        case JobStatus.Closed:
            statusLabel = i18next.t(`statuses.${JobStatus.Closed}`);
            break;
        case JobStatus.Suspended:
            statusLabel = i18next.t(`statuses.${JobStatus.Suspended}`);
            break;
        case JobStatus.Legacy:
            statusLabel = i18next.t(`statuses.${JobStatus.Legacy}`);
            break;
        default:
            break;
    }
    return statusLabel;
};

export const getJobApplicationStatusLabel = (status: string) => {
    let statusLabel = '';
    switch (status) {
        case JobApplicationStatuses.new:
            statusLabel = i18next.t(`statuses.${JobApplicationStatuses.new}`);
            break;
        case JobApplicationStatuses.hired:
            statusLabel = i18next.t(`statuses.${JobApplicationStatuses.hired}`);
            break;
        case JobApplicationStatuses.declined:
        case JobApplicationStatusUpdateValues.reject:
            statusLabel = i18next.t(
                `statuses.${JobApplicationStatuses.declined}`
            );
            break;
        case JobApplicationStatuses.inReview:
            statusLabel = i18next.t(
                `statuses.${JobApplicationStatuses.inReview}`
            );
            break;
        case JobApplicationStatuses.withdrawn:
        case JobApplicationStatusUpdateValues.withdraw:
            statusLabel = i18next.t(
                `statuses.${JobApplicationStatuses.withdrawn}`
            );
            break;
        default:
            break;
    }
    return statusLabel;
};
